import React, { useState } from "react";
import { Button } from "@material-ui/core";
import Microsoft from "./../assets/images/microsoft.png";
import UserService from "./../user/UserService";
import { msalInstance } from '../authConfig';
import CommonDialog from "./CommonDialog";

const SignIn = ({ onSignIn }) => {

  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState("");

  const handleDialogClose = () => {
    setErrorDialogOpen(false);
  };

  const handleLogin = async () => {


    try {

      if (msalInstance.getAccount() !== null) {
        await acquireToken();
      } else {
        await msalInstance.loginPopup({ scopes: ['openid', 'email', 'profile', 'user.read'] });
        await acquireToken();
      }

    } catch (error) {
      console.log(error);
    }
  };

  const acquireToken = async () => {
    try {
      const tokenResponse = await msalInstance.acquireTokenPopup({ scopes: ['openid', 'email', 'profile', 'user.read'] });

      await UserService.loginToken(tokenResponse).then(async (response) => {
        if (response) {
          await UserService.validatePermisos();
          onSignIn(response);
        }
      })
    } catch (error) {
      if (error.status === 409) {
        setErrorDialogMessage(error.data.message);
        setErrorDialogOpen(true);
      } else {
        console.error("Error al adquirir el token de acceso: " + error);
      }
    }
  }

  return (
    <>
      <Button className="buttonSSO" size={"large"} onClick={() => handleLogin()} startIcon={<img src={Microsoft} alt="Microsoft Entra ID" />} >
        Iniciar Sesion con Microsoft
      </Button>
      <CommonDialog
        open={errorDialogOpen}
        disableBackdropClick
        title="ATENCIÓN"
        backgroundTitle={"rgb(241, 206, 47)"}
        noCancelar
        maxWidth="md"
        contentText={errorDialogMessage}
        aceptarText="Intentar nuevamente"
        onClickAceptar={() => handleDialogClose()}
        onClose={() => handleDialogClose()}
      />
    </>
  );
};

export default SignIn;
